module.exports = __webpack_public_path__ + "media/newstyle/images/edit_document-c750fba0e4d0bdfbb5677eccd699e666.svg";